module.exports = __webpack_public_path__ + "static/portfolio-4-278ef563dfafd97991d115296ab76607.jpg";